import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';

import {PresetButton, PresetButtonProps} from '../PresetButton/PresetButton';

type SortablePresetButtonProps = PresetButtonProps & {
  sortableId: string;
};

export function SortablePresetButton(props: SortablePresetButtonProps) {
  const {sortableId, ...buttonProps} = props;
  const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({
    id: sortableId,
  });

  return (
    <div
      ref={setNodeRef}
      className="flex"
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.45 : 1,
      }}
      {...attributes}
      {...listeners}
    >
      <PresetButton {...buttonProps} />
    </div>
  );
}
